import React from "react";
import styled from "styled-components/macro";

function Section({ children, height = "432" }) {
	return (
		<CustomSection height={height}>
			{React.Children.map(children, (child, index) => {
				const { title, border ="#F0F0F0", background="#fff", growFactor = 1 } = child.props;
				return (
                    <InnerSection key={index} className="p-4" grow={growFactor} background={background} border={ border}>
						{title && <Title >{title}</Title>}
						{child}
					</InnerSection>
				);
			})}
		</CustomSection>
	);
}

Section.displayName = "Section";
export default Section;

const CustomSection = styled.div`
	width: 100%;
	display: flex;
	gap: 16px;
	background: transparent;
	height: ${(props) => props.height}px;
`;

const InnerSection = styled.div`
	flex: ${({ grow }) => grow};
	display: flex;
	flex-direction: column;
	gap: 4px;
	height: 100%;
	border-radius: 4px;
	background: ${({ background }) => background};
	border: 1px solid ${({ border }) => border};
`;

const Title = styled.div`
	color: #262626;
	font-family: "Inter";
	font-size: 14px;
	font-style: normal;
	font-weight: 600;
	line-height: 16px;
    padding-bottom: 24px;
`;
